export default "__VITE_ASSET__BSIH9KuR__"